export const PLACE_ORDER = "PLACE_ORDER";
export const BOOK_SERVICE = "BOOK_SERVICE";
